import React, { FC } from 'react';
import { Button, Col, Form, Row, Typography } from 'components';
import styles from 'components/common/ContactFieldManager/ContactInfoCard/styles.module.scss';
import { CloseIcon, CloseIconLight, DoneIcon, EditIconLight } from 'components/common/icons';
import { Input } from 'antd';
import { webSiteUrlRegex } from 'utils/helpers';

const { Item } = Form;
const { Text } = Typography;

export type WebsiteDataType = {
  label: string;
  id: string;
};

interface IWebsite {
  onWebsiteItemRemove: (id: string) => void;
  onWebsiteItemEdit: (id: string) => void;
  onWebsiteItemSave: (id: string) => void;
  onWebsiteItemCancel: () => void;
  data: WebsiteDataType;
  isEditeMode: boolean;
}

export const WebsiteItemCard: FC<IWebsite> = React.memo((props) => {
  const { data, onWebsiteItemRemove, onWebsiteItemEdit, isEditeMode, onWebsiteItemSave, onWebsiteItemCancel } = props;
  const { label, id } = data;
  return (
    <Col span={24}>
      {!isEditeMode && (
        <Row className={styles.main} align={'middle'} justify={'space-between'}>
          <Col>
            <Text>{label}</Text>
          </Col>
          <Col>
            <Row align={'middle'}>
              <Col>
                <Button
                  size={'small'}
                  type={'link'}
                  icon={<EditIconLight />}
                  onClick={() => {
                    onWebsiteItemEdit(id);
                  }}
                />
              </Col>
              <Col>
                <Button
                  size={'small'}
                  type={'link'}
                  icon={<CloseIconLight />}
                  onClick={() => onWebsiteItemRemove(id)}
                />
              </Col>
            </Row>
          </Col>
        </Row>
      )}
      {isEditeMode && (
        <Row gutter={[0, 16]}>
          <Col span={24}>
            <Item
              name="edit_website"
              label={'Website'}
              rules={[{ pattern: webSiteUrlRegex, message: 'Please enter a valid website URL.' }]}
            >
              <Input size={'large'} />
            </Item>
          </Col>
          <Col span={24}>
            <Row gutter={4} justify={'end'}>
              <Col>
                <Button color="default" variant="filled" onClick={onWebsiteItemCancel} icon={<CloseIcon />} />
              </Col>
              <Col>
                <Button onClick={() => onWebsiteItemSave(id)} type={'primary'} icon={<DoneIcon />} />
              </Col>
            </Row>
          </Col>
        </Row>
      )}
    </Col>
  );
});
